import withRouter from 'react-router/lib/withRouter';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { map, keyBy, isNull } from 'lodash';
import Joi from 'joi-full';
import FormShopsAndRates from '../components/FormShopsAndRates';
import { syncValidateData } from '../../../../common/validator';
import { getShops } from '../../../../auth/selectors';
import { TAXES_FORM_SHOPS } from '../constants';

const schema = Joi.object()
  .keys({
    shops: Joi.object()
      .pattern(/^[\w-]+$/, Joi.object({
        enabled: Joi.bool(),
        percentage: Joi.number()
          .min(0)
          .max(100)
          .required(),
      })
        .min(1)),
  });

const validate = values => syncValidateData(values, schema);

const withShopsInitialValues = withProps((ownProps) => {
  const { shops, tax, initialValues } = ownProps;
  const assignments = map(tax.assignments, ({ ownerId, percentage }) => ({
    id: ownerId,
    percentage: isNull(percentage) ? initialValues.percentage : percentage,
    enabled: true,
  }));
  const shopsInitialValues = keyBy(assignments, 'id');
  shops.forEach(({ id }) => {
    if (shopsInitialValues[id]) {
      return;
    }

    shopsInitialValues[id] = { id, percentage: tax.percentage, enabled: false };
  });

  return {
    initialValues: {
      ...initialValues,
      shops: shopsInitialValues,
    },
  };
});

const form = reduxForm({
  form: TAXES_FORM_SHOPS,
  validate,
});

const FormShopsAndRatesContainer = compose(
  withRouter,
  connect(state => ({
    shops: getShops(state),
  })),
  withShopsInitialValues,
  form,
)(FormShopsAndRates);

export default FormShopsAndRatesContainer;
